import { useHistory, useParams } from "react-router";
import "../material-details.scss";
import { useContext } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import { useManageFeatureInstanceDetails } from "entity-app/hooks/feature-details-page";
import { ProjectPermissionEnum } from "constants/index";
import { FeatureTypes } from "entity-app/constants";
import MaterialDetailCards from "./material-details-cards";
import FeatureHeader from "./material-header/material-header";

function FeatureMaterialDetails() {
  const history = useHistory();
  const { projectId, materialId } = useParams() as any;
  const { tokenContents } = useContext(ProjectContext);

  const { featureInstanceData, actions } = useManageFeatureInstanceDetails(
    materialId,
    FeatureTypes.MATERIALS
  );

  const cannotWriteAccessOfMaterial = isPermissionNotGrantted(
    ProjectPermissionEnum.CreateMaterial,
    tokenContents?.role!
  );

  const goBackToList = () => {
    history.push(`/project/${projectId}/materials`);
  };

  return (
    <div
      className="grow flex-col bg-ciq-gray-600"
      data-testid="feature-material-details-root"
    >
      <FeatureHeader
        featureInstanceData={featureInstanceData}
        title="Material Details"
        subTitle=""
        actions={actions}
        number={featureInstanceData?.auto_inc_value}
        headerTitle={featureInstanceData?.title}
        status={featureInstanceData?.feature_workflow_instance?.milestone_state}
        disabled={cannotWriteAccessOfMaterial}
        goBackToList={goBackToList}
        feature="MATERIALS"
        data-testid="feature-material-details-header"
      />
      <MaterialDetailCards
        featureInstanceData={featureInstanceData}
        actions={actions}
        featureId={materialId}
        data-testid="feature-material-details-cards"
      />
    </div>
  );
}

export default FeatureMaterialDetails;
